/*!

=========================================================
* Paper Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch } from "react-router-dom";

import Navbar from "components/Navbars/Navbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import NhanVien from "pages/Staff"
import CapNhap from "pages/Update"
import Plugin from "pages/Plugin"
import Dll from "pages/Dll"
import UserReport from "pages/UserReport"
import AdminReport from "pages/AdminReport"
import NgonNgu from "pages/Languages"
import ServerStatus from "pages/ServerStatus";
import AuthService from "../services/auth.service"
import Tools from "pages/Tools"
import DownloadFile from "pages/SharedFiles"
import DHBRenderModel from "pages/DHBRenderModel"
import DHBStream from "pages/DHBStream"
import ToolDetails from "features/Tools/ToolDetails"
import Resources from "pages/Resources"
import SocketManager from "pages/SocketManager"
import ChatManager from "pages/ChatManager"
import SystemSettings from "pages/SystemSettings"

import { ToolProvider } from "contexts/ToolContext"
import { PageProvider } from "contexts/PageContext"

import routes from "routes.js";

var ps;

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            backgroundColor: "black",
            activeColor: "info",
            newRoutes: []
        };
        this.mainPanel = React.createRef();
    }
    componentDidMount() {
        // if (navigator.platform.indexOf("Win") > -1) {
        //   ps = new PerfectScrollbar(this.mainPanel.current);
        //   document.body.classList.toggle("perfect-scrollbar-on");
        // }
        this.logged()
        this.administratorPrivileges()
        // this.getToolFromServer()
    }
    componentWillUnmount() {
        if (navigator.platform.indexOf("Win") > -1) {
            ps.destroy();
            document.body.classList.toggle("perfect-scrollbar-on");
        }
    }
    componentDidUpdate(e) {
        if (e.history.action === "PUSH") {
            this.mainPanel.current.scrollTop = 0;
            document.scrollingElement.scrollTop = 0;
        }
    }

    administratorPrivileges() {
        const user = JSON.parse(localStorage.getItem('user'));
        if (user.role == "ADMIN") {
            routes.push({
                path: "/staff",
                name: "Staff",
                icon: "fas fa-users",
                component: NhanVien,
                layout: "/admin",
            })

            // Gắn cờ divider: true
            routes.push({
                divider: true,
                path: "/divider",
                name: "divider",
                layout: "/admin",
            });
        }

        routes.push({
            path: "/dashboard",
            name: "Server Status",
            icon: "fas fa-server",
            component: ServerStatus,
            layout: "/admin",
            exact: true
        })

        routes.push({
            path: "/settings",
            name: "Settings",
            icon: "fas fa-cog",
            layout: "/admin",
            children: [
                {
                    path: "/settings",
                    name: "Website",
                    icon: "fas fa-globe",
                    component: SystemSettings,
                    layout: "/admin",
                },
                {
                    path: "/dhbstream",
                    name: "DHB Stream",
                    icon: "fas fa-broadcast-tower",
                    component: DHBStream,
                    layout: "/admin",
                },
                {
                    path: "/dhbrender-model",
                    name: "DHB Render",
                    icon: "fas fa-brain",
                    component: DHBRenderModel,
                    layout: "/admin",
                },
            ]
        })



        // Gắn cờ divider: true
        routes.push({
            divider: true,
            path: "/divider",
            name: "divider",
            layout: "/admin",
        });

        routes.push({
            path: "/socket-manager",
            name: "Socket Manager",
            icon: "fas fa-plug",
            component: SocketManager,
            layout: "/admin",
        })

        routes.push({
            path: "/chat-manager",
            name: "Chat Manager",
            icon: "fas fa-comments",
            component: ChatManager,
            layout: "/admin",
        })

        // Route cho chi tiết tools - không hiển thị trong sidebar
        routes.push({
            path: "/tools/:matool",
            component: ToolDetails,
            layout: "/admin",
            hidden: true
        })

        routes.push({
            path: "/tools",
            name: "Tool Management",
            icon: "fas fa-tools",
            component: Tools,
            layout: "/admin",
            exact: true
        })

        routes.push({
            path: "/language",
            name: "Language",
            icon: "fas fa-language",
            component: NgonNgu,
            layout: "/admin",
        })

        // Gắn cờ divider: true
        routes.push({
            divider: true,
            path: "/divider",
            name: "divider",
            layout: "/admin",
        });

        routes.push({
            path: "/update",
            name: "Update",
            icon: "fas fa-cloud-upload-alt",
            component: CapNhap,
            layout: "/admin",
        })

        routes.push({
            path: "/plugin",
            name: "Plugin",
            icon: "fas fa-puzzle-piece",
            component: Plugin,
            layout: "/admin",
        })

        routes.push({
            path: "/dll",
            name: "Dll",
            icon: "fas fa-file-code",
            component: Dll,
            layout: "/admin",
        })

        routes.push({
            path: "/resources",
            name: "Resource",
            icon: "fas fa-box-open",
            component: Resources,
            layout: "/admin",
        })

        // Gắn cờ divider: true
        routes.push({
            divider: true,
            path: "/divider",
            name: "divider",
            layout: "/admin",
        });

        routes.push({
            path: "/shared-files",
            name: "Shared File",
            icon: "fas fa-share-alt",
            component: DownloadFile,
            layout: "/admin",
        })

        // Gắn cờ divider: true
        routes.push({
            divider: true,
            path: "/divider",
            name: "divider",
            layout: "/admin",
        });

        routes.push({
            path: "/user-reports",
            name: "User Report",
            icon: "fas fa-exclamation-circle",
            component: UserReport,
            layout: "/admin",
        })

        routes.push({
            path: "/admin-reports",
            name: "Admin Report",
            icon: "fas fa-bug",
            component: AdminReport,
            layout: "/admin",
        })

        this.setState({ newRoutes: routes })
    }

    logged() {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user) {
            window.location = "/admin/login";
            return;
        }
    }

    getTool() {
        const queryPath = window.location.pathname;
        return queryPath.replace(/admin/gi, '').replace(/[^a-zA-Z0-9 ]/g, '')
    }

    getBrand(arr) {
        let brandName = ''
        arr.map((prop) => {
            if (prop.children) {
                prop.children.forEach((child) => {
                    if (window.location.href.indexOf(child.layout + child.path) !== -1) {
                        brandName = child.name;
                    }
                });
            } else if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
                brandName = prop.name;
            }
            return null;
        });
        return brandName
    }

    render() {
        const { newRoutes } = this.state
        return (
            <PageProvider>
                <ToolProvider>
                    <div className="wrapper">
                        <Sidebar
                            {...this.props}
                            routes={newRoutes.filter(route => !route.hidden)}
                            bgColor={this.state.backgroundColor}
                            activeColor={this.state.activeColor}
                        />
                        <div className="main-panel" ref={this.mainPanel}>
                            <Navbar title={this.getBrand(newRoutes)} {...this.props} />
                            <Switch>  {
                                newRoutes.flatMap((prop, key) => {
                                    // Parent with children → render child routes
                                    if (prop.children) {
                                        return prop.children.map((child, cKey) => (
                                            <Route
                                                path={child.layout + child.path}
                                                component={child.component}
                                                key={`${key}-${cKey}`}
                                                exact={child.exact}
                                            />
                                        ));
                                    }
                                    // Normal route
                                    return (
                                        <Route
                                            path={prop.layout + prop.path}
                                            component={prop.component}
                                            key={key}
                                            exact={prop.exact}
                                        />
                                    );
                                })
                            }</Switch>
                            {/* <Footer fluid /> */}
                        </div>
                    </div>
                </ToolProvider>
            </PageProvider>
        );
    }
}

export default Dashboard;
